import { getDepartureFromListAction } from "../../../Actions/LogicActions/Search/GetDepartureFromListAction";
import { getTodayTrainFromListAction } from "../../../Actions/LogicActions/Search/GetTodayTrainFromListAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { evtTree } from "../../../Orchestrator/ConstantTree";

export class DepartureFromStep extends StepFlow {
    get stepName() { return "DepartureFromStep"; }

    async onEventSetup(): Promise<void> {
        this.registerEventSubscription(
            _eventBus.on({
                eventName: evtTree.departureFrom.Get,
                handler: async () => {
                    getDepartureFromListAction.execute();
                }
            })
        );

        // Disabled — getTodayTrainFromListAction loops every station and fires
        // /retailer/offers per pair (12 calls + several 400s). Slider is hidden;
        // re-enable when bringing the widget back.
        // this.registerEventSubscription(
        //     _eventBus.on({
        //         eventName: evtTree.todayTrainFrom.Get,
        //         handler: async () => {
        //             getTodayTrainFromListAction.execute();
        //         }
        //     })
        // );
    }

    async onExecute(): Promise<void> {
        if (window && (window.location.pathname === "/" || window.location.pathname === "")) {
            console.log("DepartureFromStep Init Step Execute...");
            console.log("TodayTrainFromStep Init Step Execute...");
            this.eventBus.emit({
                eventName: evtTree.departureFrom.Get,
            });

            this.eventBus.emit({
                eventName: evtTree.todayTrainFrom.Get,
            });
        }

    }
}
export const departureFromStepDeclaration = new StepDefinition({
    stepName: "DepartureFromStep",
    stepClass: DepartureFromStep
});
